var map = {
	"./1.png": 1462,
	"./10.png": 4125,
	"./2.png": 7514,
	"./3.png": 2803,
	"./4.png": 5649,
	"./5.png": 8564,
	"./6.png": 526,
	"./7.png": 8218,
	"./8.png": 3017,
	"./9.png": 902,
	"./Globaljoy.png": 3268,
	"./android.png": 9825,
	"./bag.png": 1755,
	"./btn_more.png": 3923,
	"./companyNtrBg.png": 1000,
	"./companyProduct.png": 5362,
	"./contactUsBg.png": 6318,
	"./culture/afternoonTea/1.png": 8748,
	"./culture/afternoonTea/2.png": 3925,
	"./culture/afternoonTea/3.png": 2950,
	"./culture/afternoonTea/4.png": 7445,
	"./culture/birthday/1.png": 2601,
	"./culture/birthday/2.png": 671,
	"./culture/birthday/3.png": 1818,
	"./culture/club/1.png": 4975,
	"./culture/club/2.png": 4315,
	"./culture/club/3.png": 9186,
	"./culture/club/4.png": 1557,
	"./culture/festival/1.png": 875,
	"./culture/festival/2.png": 6907,
	"./culture/festival/3.png": 5895,
	"./culture/festival/4.png": 4755,
	"./culture/festival/5.png": 7265,
	"./culture/life/1.png": 2773,
	"./culture/mainImg1.png": 5098,
	"./culture/mainImg2.png": 6997,
	"./culture/mainImg3.png": 8017,
	"./culture/mainImg4.png": 25,
	"./culture/sub1.png": 4385,
	"./culture/sub2.png": 9926,
	"./culture/sub3.png": 1192,
	"./culture/sub4.png": 4234,
	"./culture/tourism/1.png": 3313,
	"./culture/tourism/2.png": 8621,
	"./culture/tourism/3.png": 8814,
	"./culture/tourism/4.png": 5711,
	"./culture/tourism/5.png": 8321,
	"./culture/tourism/6.png": 2419,
	"./culture/tourism/7.png": 7436,
	"./dizhi.png": 7049,
	"./gps.png": 2733,
	"./growthProcess.png": 3532,
	"./hme_top.png": 800,
	"./huojian.png": 7550,
	"./icon1.png": 2718,
	"./icon2.png": 6319,
	"./icon3.png": 4232,
	"./icon4.png": 4905,
	"./icon5.png": 7034,
	"./icon6.png": 7918,
	"./ios.png": 185,
	"./jianjie_icon_1.png": 1562,
	"./jianjie_icon_2.png": 3489,
	"./jianjie_icon_3.png": 275,
	"./jianjie_icon_4.png": 2708,
	"./jianjie_icon_5.png": 2160,
	"./joinUsBanner.png": 9075,
	"./lianxi.png": 2041,
	"./line2.png": 7259,
	"./line3.png": 4429,
	"./line4.png": 2430,
	"./navBg.png": 4976,
	"./shouji.png": 7345,
	"./swiper-left-light.png": 4751,
	"./swiper-left.png": 8169,
	"./swiper-right-light.png": 5352,
	"./swiper-right.png": 4006,
	"./tit_left.png": 7571,
	"./userTitle.png": 6737,
	"./welfareContent.png": 5549,
	"./welfareContent/welfare1.png": 7328,
	"./welfareContent/welfare10.png": 3133,
	"./welfareContent/welfare11.png": 7453,
	"./welfareContent/welfare12.png": 6126,
	"./welfareContent/welfare2.png": 8271,
	"./welfareContent/welfare3.png": 9631,
	"./welfareContent/welfare4.png": 8556,
	"./welfareContent/welfare5.png": 6719,
	"./welfareContent/welfare6.png": 7862,
	"./welfareContent/welfare7.png": 2717,
	"./welfareContent/welfare8.png": 6889,
	"./welfareContent/welfare9.png": 5507,
	"./youjiantou.png": 7569,
	"./zuojiantou.png": 3848,
	"./图片 (3).png": 4398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4548;